import { Col, Drawer, Row } from "antd";
import { FC, useState } from "react";
import {
  DevCardClass,
  DevCardObject,
} from "../../../classesAndInterfaces/DevCard";
import DevCard from "../../../components/DevCard/DevCard";
import SwipingCarousal from "../../../components/SwipingCarousal/SwipingCarousal";
import {
  awsCardDescription,
  awsTechnologiesAndTools,
} from "../../../textFiles/aws";
import {
  backendCardDescription,
  backendTechnologiesAndTools,
} from "../../../textFiles/backend";
import {
  frontendCardDescription,
  frontendTechnologiesAndTools,
} from "../../../textFiles/frontend";
import FrontendCover from "../../../assets/frontend.svg";
import BackendCover from "../../../assets/backend.svg";
import AwsCover from "../../../assets/aws.svg";
import { Typography } from "antd";

const { Title } = Typography;

const devCardArray: DevCardObject[] = [
  new DevCardClass({
    title: "frontend",
    description: frontendCardDescription,
    image_url: FrontendCover,
    techonologiesAndTools: frontendTechnologiesAndTools,
  }),
  new DevCardClass({
    title: "aws",
    description: awsCardDescription,
    image_url: AwsCover,
    techonologiesAndTools: awsTechnologiesAndTools,
  }),
  new DevCardClass({
    title: "backend",
    description: backendCardDescription,
    image_url: BackendCover,
    techonologiesAndTools: backendTechnologiesAndTools,
  }),
];

const SkillCards: FC = () => {
  const [drawer, setDrawer] = useState(false);

  const openDrawer = () => {
    setDrawer(true);
  };

  return (
    <Row align={"middle"} justify={"center"} gutter={[24, 24]}>
      <Col span={24}>
        <Row align={"middle"} justify={"center"} gutter={[24, 24]}>
          <Title level={2}><a href="#domains">Domains</a></Title>
        </Row>
      </Col>
      <Col span={24}>
        <SwipingCarousal>
          {devCardArray.map((card: DevCardObject, index: number) => {
            return (
              <Col key={index}>
                <DevCard
                  title={card.title}
                  description={card.description}
                  image_url={card.image_url}
                  techonologiesAndTools={card.techonologiesAndTools}
                  openDrawer={openDrawer}
                />
              </Col>
            );
          })}
        </SwipingCarousal>
      </Col>
      {/* <Drawer
          title="Multi-level drawer"
          width={'100%'}
          closable={false}
          onClose={()=>{setDrawer(false)}}
          visible={drawer}
        ></Drawer> */}
    </Row>
  );
};

export default SkillCards;
